



import Check from "rutas/check";
import Paciente from "views/diagnostico/paciente.js";
import Tratamiento from "views/diagnostico/tratamiento/tratamiento.js";
import Consultas from "views/diagnostico/tratamiento/consultas.js";
import Diagnostico from "views/diagnostico/tratamiento/diagnostico.js";
import Ficha from "views/diagnostico/ficha";
import MSDK from "views/maps/m-sdk";
import Icons from "views/Icons";
import { redirect } from "react-router-dom";
import ReportesTratamiento from "views/diagnostico/reportes/reportes_tratamiento";
import ReportesDiagnostico from "views/diagnostico/reportes/reportes_diagnostico";

var RoutesUBE = [

  {
    path: "/pacientes",
    name: "PACIENTES",
    icon: " tim-icons  icon-single-02",
    component: <Paciente />,
    layout: "/tratamiento",
  },

  {
    path: "/fichas",
    name: "FICHA",
    icon: " tim-icons  icon-badge",
    component: <Ficha />,
    layout: "/tratamiento",
  },
  {
    path: "/diagnostico",
    name: "DIAGNOSTICO",
    icon: " tim-icons  icon-molecule-40",
    component: <Diagnostico />,
    layout: "/tratamiento",
    // redirect
  },

  {
    path: "/tratamiento",
    name: "TRATAMIENTOS",
    icon: " tim-icons  icon-heart-2",
    component: <Tratamiento />,
    layout: "/tratamiento",
    // redirect
  },
  {
    path: "/reportes-tratamiento",
    name: "REPORTES TTO",
    icon: " tim-icons  icon-heart-2",
    component: <ReportesTratamiento />,
    layout: "/tratamiento",
    // redirect
  },
  {
    path: "/reportes-diagnostico",
    name: "REPORTES DIAGNOSTICOS",
    icon: " tim-icons  icon-heart-2",
    component: <ReportesDiagnostico />,
    layout: "/tratamiento",
    // redirect
  },



  // {
  //   path: "/consultas/:paciente/:id_tratamiento",
  //   name: "CONSULTAS",
  //   icon: " tim-icons  icon-single-02",
  //   component: <Consultas />,
  //   layout: "/tratamiento",
  //   redirect
  // },

  {
    path: "/georef",
    name: "Georeferenciaciones UBE",
    icon: "tim-icons icon-pin",
    componet: <Check component={MSDK} />,
    layout: "/tratamiento",
  },

  // {
  //   path: "/icons",
  //   name: "icons",
  //   icon: "tim-icons icon-pin",
  //   component: <Icons />,
  //   layout: "/tratamiento",
  // },



];
export default RoutesUBE;
